module.exports = __webpack_public_path__ + "img/healthcheck-head.7205fb5c.png";